export enum ADDITIONAL_FIELDS {
  PART_NUMBER = 'PART_NUMBER',
  CONNECT_CODE = 'CONNECT_CODE',
  CONTRACT_CODE = 'CONTRACT_CODE',
  OPEN_TEXT = 'OPEN_TEXT'
}
